import Card from 'components/Layout/Card'
import PostList from 'components/Layout/PostList'
import TabLayout from 'components/Layout/TabLayout'
import React, { useState } from 'react'
import { useParams } from 'react-router-dom'

const PostAndNetworksDetails = () => {
  const params = useParams()
  const { userId } = params
  const [activeTab, setActiveTab] = useState('my-posts')

  const tabs = [
    { key: 'my-posts', label: 'Post created' },
    { key: 'liked-posts', label: 'Likes' },
    { key: 'saved-posts', label: 'Saved' },
  ]

  return (
    <Card className='cmt-10 cps-20 cpe-20 cpt-10 cpb-10'>
      <div className="cmb-10">
        <TabLayout
          tabs={tabs}
          activeKey={activeTab}
          onChange={(key) => setActiveTab(key)}
          variant="underline"
        />
      </div>

      <PostList
        type={activeTab}
        userId={userId}
      />
    </Card>
  )
}

export default PostAndNetworksDetails
